import Script from 'next/script'

import { initScript } from '@repo/analytics/openai'
import { useIubendaConfig } from './iubenda'

export const OpenAiPixel = () => {
  const { scriptProps, variant } = useIubendaConfig()

  if (variant === 'locationNotSet') {
    return null
  }

  return (
    <Script id="openai-pixel-script" strategy="afterInteractive" {...scriptProps}>
      {initScript}
    </Script>
  )
}
